
const PreDepartureToolkitData = [
    {
        id: 1,
        bannerImg: require("../../../Assets/Gulf_Students/Pre-Departure/Visa-checklist-guidance.png"),
        text: "Visa checklist & other guidance"
    },
    {
        id: 2,
        bannerImg: require("../../../Assets/Gulf_Students/Pre-Departure/Travel-prep-guide.png"),
        text: "Travel prep guide (packing, SIM cards, banking)"
    },
    {
        id: 3,
        bannerImg: require("../../../Assets/Gulf_Students/Pre-Departure/Cultural-orientation-webinar.png"),
        text: "Cultural orientation webinar replay"
    },
    {
        id: 4,
        bannerImg: require("../../../Assets/Gulf_Students/Pre-Departure/Airport-arrival-tips.png"),
        text: "Airport arrival tips & housing starter kit"
    }
];

export default PreDepartureToolkitData;